export class SolicitudRegistrarRenovacionDocumentoModel {
  idSolicitud: number;
  codigoSolicutd: string;
  idSolicitudPersonaDocumento: number;

  fechaVencimiento: Date;
  nombreArchivo: string;
  comentarios: string;

  constructor() {
    this.idSolicitud = 0;
    this.codigoSolicutd = '';
    this.idSolicitudPersonaDocumento = 0;
    this.fechaVencimiento = new Date();
    this.nombreArchivo = '';
    this.comentarios = '';
  }
}
